"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouterDom = require("react-router-dom");

var _styles = require("@material-ui/core/styles");

var _solarReact = require("@solar/solar-react");

var _excluded = ["classes", "className", "to"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      fontSize: '0.8em',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none'
      }
    },
    navItemRoot: {
      '&:hover': {
        backgroundColor: theme.palette.secondary[100]
      }
    },
    ripple: {
      backgroundColor: theme.palette.secondary[800] // for TouchRipple color

    },
    listItemText: {
      whiteSpace: 'nowrap'
    },
    listItemIcon: {},
    listItem: {
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2)
    },
    navItemActive: {
      '& $listItem': {
        backgroundColor: theme.palette.secondary[100]
      },
      '& $listItemText, & $listItemIcon': {
        color: theme.palette.secondary[600] // color: 'rgba(0, 0, 0, 0.8)',

      }
    },
    createButton: {
      margin: 20
    }
  };
});

var NavItem = function NavItem(_ref) {
  var eClasses = _ref.classes,
      className = _ref.className,
      to = _ref.to,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    classes: eClasses
  });
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, _extends({
    to: to,
    className: (0, _classnames["default"])(classes.root, className),
    activeClassName: classes.navItemActive
  }, other), /*#__PURE__*/_react["default"].createElement(_solarReact.NavItem, _extends({
    TouchRippleProps: {
      classes: {
        child: classes.ripple
      }
    },
    TypographyProps: {
      variant: 'body2'
    },
    classes: {
      root: classes.navItemRoot,
      listItem: classes.listItem,
      listItemText: classes.listItemText,
      listItemIcon: classes.listItemIcon
    }
  }, other)));
};

NavItem.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  icon: _propTypes["default"].node,
  label: _propTypes["default"].string.isRequired,
  to: _propTypes["default"].string.isRequired
};
NavItem.defaultProps = {
  className: '',
  icon: ''
}; // prettier-ignore

var _default = NavItem;
exports["default"] = _default;